var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"detailmain",attrs:{"id":"app"}},[(_vm.isLoading)?_c('div',{staticClass:"loading-container"},[_c('van-loading')],1):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }